<!--<div class="right-side p-5">
  <h2>On Spot Registration Details</h2>
  <form [formGroup]="onspotform">
    <div class="section">

      <div class="report-container">

        <div class="row">
          <div class="text-end">
            <button id="btncreate" type="button" (click)="CreateNewRegistration(uniqueEventId)" class="btn btn-primary btn-sm me-2">Create New Spot Registration</button>
          </div>&nbsp;

          <div class="mt-4">

            <div class="row">
              <div class="text-end">
                <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">Export to Excel</button>
              </div>

              <div class="col-lg-7 col-sm-12">
                <div class="search-container">
                  <mat-form-field class="search-input w-75" appearance="outline">
                    <mat-label>Search</mat-label>
                    <input matInput formControlName="searchControl" />
                  </mat-form-field>
                  <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(onspotform.get('searchControl')?.value ?? '')" id="btnSearch">
                    <i class="bi bi-search fs-4"></i>
                  </button>
                  <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                    <i class="bi bi-arrow-clockwise fs-4"></i>
                  </button>
                </div>
                <div *ngIf="onspotform.get('searchControl')?.invalid && (onspotform.get('searchControl')?.touched || onspotform.get('searchControl')?.dirty)">
                  <small *ngIf="onspotform.get('searchControl')?.errors?.['pattern']" class="text-danger">
                    Invalid search term.
                  </small>
                </div>
              </div>
            </div>


            <div class="table-responsive">
              <table class="table table-striped table-bordered table-hover" style="font-size:9.5pt">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Enterprise Name</th>
                    <th>Participant Name</th>
                    <th>Email</th>
                    <th>Designation</th>
                    <th>Mobile</th>
                    <th>GST Number</th>
                    <th>Action</th>
                    <th>License Under Factories Act Certificate</th>
                    <th>Registration Under Shops And Estbmt Act Certificate</th>
                    <th>Trade License Certificate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of reportData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.enterpriseName }}</td>
                    <td>{{ item.participantName }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.designation }}</td>
                    <td>{{ item.mobileNumber}}</td>
                    <td>{{item.gstNumber}}</td>
                    <td style="text-align:center">-->
<!--@if(item.uniqueEventId)-->
<!--<span *ngIf="item.onSpotUserId" (click)="onEdit(item.onSpotUserId)" class="btn btn-primary btn-sm me-2"><i class="bi bi-pencil"></i> Edit</span>-->
<!--<ng-container *ngif="istoday(event.eventdate)">-->
<!--<button>On Spot Registration</button>-->
<!--<button (click)="DownloadTicket(event.eventId)" class="btn btn-warning btn-sm">-->
<!--<button (click)="DownloadTicket(item.eventId)" class="btn btn-warning btn-sm">
  <i class="bi bi-download"></i> Download Ticket
</button>-->
<!--</ng-container>-->
<!--</td>-->
<!-- License Under Factories Act Certificate -->
<!--<td class="text-center">
  <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="item.licenseUnderFactoriesActCertificatePath"
     (click)="onDownload(item.licenseUnderFactoriesActCertificatePath, item.licenseUnderFactoriesActCertificate); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
    <i class="bi bi-download"></i> Download
  </a>
</td>-->
<!-- Registration Under Shops and Estbmt Act Certificate -->
<!--<td class="text-center">
  <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="item.registrationUnderShopsAndEstbmtActCertificatePath"
     (click)="onDownload(item.registrationUnderShopsAndEstbmtActCertificatePath, item.registrationUnderShopsAndEstbmtActCertificate); $event.preventDefault()"
     style="text-decoration: underline; cursor: pointer">
    <i class="bi bi-download"></i> Download
  </a>

</td>-->
<!-- Trade License Certificate -->
<!--<td class="text-center">
                    <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="item.tradeLicenseCertificatePath"
                       (click)="onDownload(item.tradeLicenseCertificatePath, item.tradeLicenseCertificate); $event.preventDefault()"
                       style="text-decoration: underline; cursor: pointer">
                      <i class="bi bi-download"></i> Download
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [disabled]="disabled"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>


        </div>
      </div>

    </div>

    </form>
</div>-->

<div class="right-side p-5">
  <h2>On Spot Registration Details</h2> 
  <form [formGroup]="onspotform">
    <div class="section">
      <div class="text-end mb-2">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">
          Export to Excel
        </button>
      </div>

      <div class="report-container">
        <div class="row">
          <div class="text-end">

            <!--<button id="btncreate" *ngIf="isTotalCount" [disabled]="isTotalCount" type="button" (click)="CreateNewRegistration(uniqueEventId)" class="btn btn-primary btn-sm me-2">
    Create New Spot Registration
  </button>-->            

            <div class="text-end">
              <button id="btncreate"
                      [disabled]="isTotalCount || onspotlimit === null || onspotlimit == 0" 
                      type="button"
                      (click)="CreateNewRegistration(uniqueEventId)"
                      class="btn btn-primary btn-sm me-2">
                Create New Spot Registration
              </button>

              <div *ngIf="onspotlimit !== null" class="mt-2 text-danger">
                <strong>On-Spot Registration Limit:</strong> {{ onspotlimit }}
              </div>

              <!-- Show message when total_count is 1 -->
              <div *ngIf="total_count" class="alert alert-danger mt-2">
                On-spot registration has reached the maximum limit.
              </div>
            </div>
          </div>
          &nbsp;

          <div class="mt-4">
            <div class="row">


              <div class="col-lg-7 col-sm-12">
                <div class="search-container">
                  <mat-form-field class="search-input w-75" appearance="outline">
                    <mat-label>Search</mat-label>
                    <input matInput formControlName="searchControl" />
                  </mat-form-field>
                  <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(onspotform.get('searchControl')?.value ?? '')" id="btnSearch">
                    <i class="bi bi-search fs-4"></i>
                  </button>
                  <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                    <i class="bi bi-arrow-clockwise fs-4"></i>
                  </button>
                </div>
                <div *ngIf="onspotform.get('searchControl')?.invalid && (onspotform.get('searchControl')?.touched || onspotform.get('searchControl')?.dirty)">
                  <small *ngIf="onspotform.get('searchControl')?.errors?.['pattern']" class="text-danger">
                    Invalid search term.
                  </small>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="enterpriseName" matSort matSortDirection="desc" matSortDisableClear>
                <ng-container matColumnDef="Sr.No">
                  <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                  <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
                </ng-container>
                <ng-container matColumnDef="onSpotUserId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header hidden="hidden">On Spot User Id</th>
                  <td mat-cell *matCellDef="let el" hidden="hidden"> {{el.onSpotUserId}} </td>
                </ng-container>
                <ng-container matColumnDef="registrationId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header hidden="hidden">registrationId</th>
                  <td mat-cell *matCellDef="let el" hidden="hidden"> {{el.registrationId}} </td>
                </ng-container>
                <ng-container matColumnDef="enterpriseName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Enterprise Name</th>
                  <td mat-cell *matCellDef="let el"> {{el.enterpriseName}} </td>
                </ng-container>
                <ng-container matColumnDef="udyamNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Number</th>
                  <td mat-cell *matCellDef="let el"> {{el.udyamNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                  <td mat-cell *matCellDef="let el"> {{el.email}} </td>
                </ng-container>

                <!--<ng-container matColumnDef="mobileNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
    <td mat-cell *matCellDef="let el"> {{el.mobileNumber}} </td>
  </ng-container>-->

                <ng-container matColumnDef="mobileNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                  <td mat-cell *matCellDef="let el">
                    {{ el.mobileNumber }}
                  </td>
                </ng-container>

                <!--<ng-container matColumnDef="gstNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>GSTNumber</th>
    <td mat-cell *matCellDef="let el"> {{el.gstNumber}} </td>
  </ng-container>-->
                <ng-container matColumnDef="gstNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>GST Number</th>
                  <td mat-cell *matCellDef="let el">
                    {{ el.gstNumber ? el.gstNumber : '-' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Actions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                  <td mat-cell *matCellDef="let el" class="text-center">
                    <button *ngIf="el.onSpotUserId" (click)="onEdit(el.onSpotUserId)" class="btn btn-primary btn-sm me-2">
                      <i class="bi bi-pencil"></i> Edit
                    </button>
                    <!--<button (click)="DownloadTicket(el.eventId)" class="btn btn-warning btn-sm">
    <i class="bi bi-download"></i> Download Ticket
  </button>-->
                    <!--<button (click)="DownloadTicket(el.uniqueEventId, el.onSpotUserId)" class="btn btn-warning btn-sm">
    <i class="bi bi-download"></i> Download Ticket
  </button>-->
                    <button (click)="DownloadTicket(el.uniqueEventId, el.onSpotUserId, el.udyamNumber, el.eventId)"
                            class="btn btn-warning btn-sm">
                      <i class="bi bi-download"></i> Download Ticket
                    </button>


                  </td>
                </ng-container>

                <!--<ng-container matColumnDef="licenseUnderFactoriesAct">
    <th mat-header-cell *matHeaderCellDef>Factories Act Certificate</th>
    <td mat-cell *matCellDef="let el" class="text-center">
      <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="el.licenseUnderFactoriesActCertificatePath"
         (click)="onDownload(el.licenseUnderFactoriesActCertificatePath, el.licenseUnderFactoriesActCertificate); $event.preventDefault()"
         style="text-decoration: underline; cursor: pointer">
        <i class="bi bi-download"></i> Download
      </a>
    </td>
  </ng-container>-->
                <!-- Registration Under Shops and Estbmt Act Certificate -->
                <!--<ng-container matColumnDef="registrationUnderShopsAndEstbmtAct">
    <th mat-header-cell *matHeaderCellDef>Shops & Estbmt Act Certificate</th>
    <td mat-cell *matCellDef="let el" class="text-center">
      <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="el.registrationUnderShopsAndEstbmtActCertificatePath"
         (click)="onDownload(el.registrationUnderShopsAndEstbmtActCertificatePath, el.registrationUnderShopsAndEstbmtActCertificate); $event.preventDefault()"
         style="text-decoration: underline; cursor: pointer">
        <i class="bi bi-download"></i> Download
      </a>
    </td>
  </ng-container>-->
                <!-- Trade License Certificate -->
                <!--<ng-container matColumnDef="tradeLicenseCertificate">
    <th mat-header-cell *matHeaderCellDef>Trade License Certificate</th>
    <td mat-cell *matCellDef="let el" class="text-center">
      <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="el.tradeLicenseCertificatePath"
         (click)="onDownload(el.tradeLicenseCertificatePath, el.tradeLicenseCertificate); $event.preventDefault()"
         style="text-decoration: underline; cursor: pointer">
        <i class="bi bi-download"></i> Download
      </a>
    </td>
  </ng-container>-->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                Row shown when there is no matching data.
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter</td>

                </tr>
              </table>

            </div>
            <mat-paginator #paginator
                           class="demo-paginator"
                           (page)="onPageChange($event)"
                           [length]="length"
                           [pageSize]="pageSize"
                           [showFirstLastButtons]="showFirstLastButtons"
                           [pageSizeOptions]="pageSizeOptions"
                           [hidePageSize]="hidePageSize"
                           [pageIndex]="pageIndex"
                           aria-label="Select page">
            </mat-paginator>

          </div>
        </div>
      </div>
    </div>
  </form> <!-- Ensure form is closed properly here -->
</div> <!-- Ensure div is closed correctly -->
